// @ts-ignore
import { LocalStorageService, APPS, CommunicationService } from '@cosmos/utilities';

export class RouteAppChangeEvent {
  static routeAppChangeEvent: RouteAppChangeEvent
  readonly RESPONSE_EVENT_NAME = 'changeApp'

  private constructor() {
    this.initEventListeners()
  }

  static init(): RouteAppChangeEvent {
    if (!RouteAppChangeEvent.routeAppChangeEvent) {
      RouteAppChangeEvent.routeAppChangeEvent = new RouteAppChangeEvent()
    }
    return RouteAppChangeEvent.routeAppChangeEvent
  }

  static destroy() { }

  //Recupera aplicativo montado ignorando a toolbar e sidenav...
  getMountedApp(newAppStatuses, ignoreKeys = ['@cosmos/toolbar', '@cosmos/sidenav']) {
    return Object.entries(newAppStatuses).filter(([key, value]) => {
      return value === 'MOUNTED' && !ignoreKeys.some(ignoredKey => key === ignoredKey);
    });
  }

  /**
   * TODO: Verificar se este método deveria estar no utilities...
   * @param sspaName string
   * @returns AppData
   */
  getAppDataBySSPAName(sspaName) {
    return Object.values(APPS).find((value: any) => value.sspa_name === sspaName);
  }

  updateTokenAtivo(appsChanged) {
    if (appsChanged.length > 0) {
      // appsChanged[0][0] = chave sspa do primeiro sistema montado na mudança de rota
      const appData: any = this.getAppDataBySSPAName(appsChanged[0][0]);
      if (appData) {
        LocalStorageService.singleton().setSystemAtivoToken(appData.chave_sistema);
        CommunicationService.singleton().emitCustomEvent(this.RESPONSE_EVENT_NAME, {});
      }
    }
  }

  initEventListeners() {
    /**
     * TODO: Verificar se o evento before-routing-event atende a todos os sistemas, se sim retirar
     * o evento app-change
     */
    window.addEventListener('single-spa:app-change', (evt: CustomEvent) => {
      // Ao trocar de aplicação por meio de rotas, alterar o token de sistema ativo
      this.updateTokenAtivo(this.getMountedApp(evt.detail.newAppStatuses));
    });
    /**
     * Adicionado este evento pois para o led a montagem ocorre antes da atualização do token ativo
     * o que ocasiona o erro do ticket EP-I50 (voltando com o history.back() o sistema conclui que 
     * o usuário não está logado e o redireciona, exibindo uma tela sem conteúdo)
     */
    window.addEventListener('single-spa:before-routing-event', (evt: CustomEvent) => {
      // Ao trocar de aplicação por meio de rotas, alterar o token de sistema ativo
      this.updateTokenAtivo(this.getMountedApp(evt.detail.newAppStatuses));
    });
  }
}
